/* eslint-disable no-unused-vars */
import React, { useEffect, useState, } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { logoutUser } from '../../services/authService';
import { useToast } from '../../Toaster/ToastContext';
import { useSelector, useDispatch } from 'react-redux';
import { clearUserData, setBranch } from '../../core/redux/action';
import { apiClient } from "../../services/apiClient";
import { Dropdown, Menu, Select } from "antd";
const { Option } = Select;

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const userData = useSelector((state) => state.user_data);
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [localUserData, setLocalUserData] = useState({
    name: capitalizeFirstLetter(localStorage.getItem("name") || "Guest"),
    user_type: capitalizeFirstLetter(localStorage.getItem("user_type") || "Unknown"),
    branch_name: capitalizeFirstLetter(localStorage.getItem("branch")),
  });
  const [firstEnabledUrl, setFirstEnabledUrl] = useState(null);

  useEffect(() => {
    const rolesPermissionsString = localStorage.getItem("rolespermissions");
    let rolesPermissions = [];

    try {
      if (rolesPermissionsString) {
        const permissionData = JSON.parse(rolesPermissionsString);
        const Data = JSON.parse(permissionData.permissions)
        rolesPermissions = Data.permissions;
        console.log("rolesPermissions", rolesPermissions)
      }
    } catch (error) {
      console.error("Error parsing rolespermissions from localStorage:", error);
    }

    if (!Array.isArray(rolesPermissions)) {
      console.warn("rolespermissions is not an array:", rolesPermissions);
      setFirstEnabledUrl(null);
      return;
    }

    let dashboardUrl = null;
    let fallbackUrl = null;
    
    for (const permission of rolesPermissions) {

      if (permission.enabled && permission.title === "Main" && Array.isArray(permission.childPage)) {

        for (const child of permission.childPage) {
          
          if (child.enabled && child.title === "Dashboard" && child.submenu && Array.isArray(child.childPage)) {
            for (const dashChild of child.childPage) {
              if (dashChild.enabled && dashChild.url && dashChild.url !== "") {
                dashboardUrl = dashChild.url;
                break;
              }
            }
            
            if (!dashboardUrl) {
              dashboardUrl = "/";
            }
            
            break;
          }
        }
        
        if (dashboardUrl) break; 
      }
      
      if (!fallbackUrl && permission.enabled && permission.url && permission.url !== "") {
        fallbackUrl = permission.url;
      }

      if (!fallbackUrl && permission.enabled && Array.isArray(permission.childPage)) {
        for (const child of permission.childPage) {
          if (child.enabled && child.url && child.url !== "") {
            fallbackUrl = child.url;
            break;
          }

          if (child.enabled && child.submenu && Array.isArray(child.childPage)) {
            for (const subChild of child.childPage) {
              if (subChild.enabled && subChild.url && subChild.url !== "") {
                fallbackUrl = subChild.url;
                break;
              }
            }
            if (fallbackUrl) break;
          }
        }
      }
    }
    
    setFirstEnabledUrl(dashboardUrl || fallbackUrl);
  }, []);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await apiClient.get('/get-all-branch');
        if (response.success) {
          setBranches(response.data);
          setSelectedBranch(response.data[0]);
          dispatch(setBranch(response.data[0]));
        }
      } catch (err) {
        console.error("Failed to fetch branches", err);
        showToast("Could not load branches", "error", "Branches");
      }
    };
    fetchBranches();
  }, []);

  const isElementVisible = (element) => {
    return element && (element.offsetWidth > 0 || element.offsetHeight > 0);
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();
      const body = document.body;
      const toggleBtn = document.getElementById('toggle_btn');
      if (body.classList.contains('mini-sidebar') && toggleBtn && isElementVisible(toggleBtn)) {
        const target = e.target.closest('.sidebar, .header-left');
        if (target) {
          body.classList.add('expand-menu');
          slideDownSubmenu();
        } else {
          body.classList.remove('expand-menu');
          slideUpSubmenu();
        }
        e.preventDefault();
      }
    };

    document.addEventListener('mouseover', handleMouseover);
    return () => {
      document.removeEventListener('mouseover', handleMouseover);
    };
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];

  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  // const getRedirectUrl = () => {
  //   if (pathname === "/") return "/pos";
  //   if (pathname === "/pos") return firstEnabledUrl || "/"; 
  //   if (pathname === firstEnabledUrl) return "/pos"; 
  //   return firstEnabledUrl || "/"; 
  // };

  const getRedirectUrl = () => {
    console.log("Current pathname:", pathname);
    console.log("First enabled URL:", firstEnabledUrl);
    
    if (pathname === "/pos") {
      // When on POS page, redirect to Dashboard or fallback URL
      return firstEnabledUrl || "/";
    }
    // From any other page, redirect to POS
    return "/pos";
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      const response = await logoutUser();
      const data = await response.json();
      if (data.success) {
        dispatch(clearUserData());
        localStorage.removeItem('rolespermissions');
        localStorage.removeItem('user_type');
        localStorage.removeItem('name');
        localStorage.removeItem('business_id');
        localStorage.removeItem('authToken');
        localStorage.removeItem('branch');
        setLoading(false);
        showToast(data.msg || 'Successfully logged out.', 'success', 'Logout');
        navigate('/signin');
      } else {
        throw new Error(data.msg || 'Logout failed.');
      }
    } catch (error) {
      setLoading(false);
      showToast(error.message || 'Logout failed. Please try again.', 'error', 'Logout');
      console.error('Logout failed:', error);
    }
  };

  const userMenuItems = [
    {
      key: "header",
      label: (
        <div className="profilename"
          style={{ width: "200px", backgroundColor: "#eef3f3", marginBottom: "10px" }}
        >
          <div className="profileset">
            <span className="user-img">
              <ImageWithBasePath
                src="assets/img/profiles/avator1.png" alt="img"
                className="img-fluid profile-circle"
              />
            </span>
            <div className="profilesets">
              <h6 style={{ fontSize: "14px" }}>{capitalizeFirstLetter(localUserData.user_type) || "Unknown Role"}</h6>
              <h5 style={{ fontSize: "12px" }}>{capitalizeFirstLetter(localUserData.name)}</h5>
            </div>
          </div>
        </div>
      ),
      disabled: true,
    },
    {
      key: "profile",
      label: (
        <Link to={route.profile} style={{ fontSize: "12px" }}>
          <FeatherIcon icon="user" className="me-2" />
          My Profile
        </Link>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      label: (
        <span style={{ fontSize: "12px", verticalAlign: "text-top" }}>
          <ImageWithBasePath
            src="assets/img/icons/log-out.svg"
            alt="img"
            className="me-2 logout-icon"
          />
          Logout
        </span>
      ),
      onClick: handleLogout,
    },
  ];

  return (
    <>
      <div className="header">
        <div className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath src="assets/img/logo.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo logo-white">
            <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo-small">
            <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
          </Link>
        </div>
        {/* /Logo */}
        <Link id="mobile_btn" className="mobile_btn" to="#" onClick={sidebarOverlay}>
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-searchinputs">
          {(localUserData.branch_name) && (
            <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
              <p style={{fontWeight: 'bold', fontSize:'15px', color:'#FF9F43'}}>
                {localUserData.branch_name}
              </p>
            </li>
          )}
            {/* <div className="top-nav-search">
              <Link to="#" className="responsive-search">
                <Search />
              </Link>
              <form action="#" className="dropdown">
                <div
                  className="searchinputs dropdown-toggle"
                  id="dropdownMenuClickable"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                >
                  <input type="text" placeholder="Search" />
                  <div className="search-addon">
                    <span>
                      <XCircle className="feather-14" />
                    </span>
                  </div>
                </div>
                <div
                  className="dropdown-menu search-dropdown"
                  aria-labelledby="dropdownMenuClickable"
                >
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="search" className="feather-16" />
                      </span>
                      Recent Searches
                    </h6>
                    <ul className="search-tags">
                      <li>
                        <Link to="#">Products</Link>
                      </li>
                      <li>
                        <Link to="#">Sales</Link>
                      </li>
                      <li>
                        <Link to="#">Applications</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="help-circle" className="feather-16" />
                      </span>
                      Help
                    </h6>
                    <p>
                      How to Change Product Volume from 0 to 200 on Inventory
                      management
                    </p>
                    <p>Change Product Name</p>
                  </div>
                  <div className="search-info">
                    <h6>
                      <span>
                        <i data-feather="user" className="feather-16" />
                      </span>
                      Customers
                    </h6>
                    <ul className="customers">
                      <li>
                        <Link to="#">
                          Aron Varu
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar1.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          Jonita
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          Aaron
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-10.jpg"
                            alt
                            className="img-fluid"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>
            </div> */}
          </li>
          {/* /Search */}

          {/* Select Store */}
          {/* {localUserData.user_type.toLowerCase() !== "owner" && (
            <li className="nav-item main-drop select-store-dropdown d-flex align-items-center">
              <Select
                showSearch
                style={{ minWidth: 200 }}
                placeholder="Select Store"
                optionFilterProp="children"
                value={selectedBranch?.id}
                onChange={(value) => {
                  const selected = branches.find((b) => b.id === value);
                  setSelectedBranch(selected);
                  dispatch(setBranch(selected));
                }}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {branches.map((branch) => (
                  <Option key={branch.id} value={branch.id}>
                    <span className="d-flex align-items-center">
                      <img
                        src={branch.logo || "assets/img/store/store-01.png"}
                        alt="logo"
                        style={{ width: 20, height: 20, marginRight: 8 }}
                      />
                      {branch.name}
                    </span>
                  </Option>
                ))}
              </Select>
            </li>
          )} */}
          {pathname === "/pos" && localUserData.user_type.toLowerCase() !== "owner" && (
            <li className="nav-item main-drop select-store-dropdown d-flex align-items-center">
              <Select
                showSearch
                style={{ minWidth: 200 }}
                placeholder="Select Store"
                optionFilterProp="children"
                value={selectedBranch?.id}
                onChange={(value) => {
                  const selected = branches.find((b) => b.id === value);
                  setSelectedBranch(selected);
                  dispatch(setBranch(selected));
                }}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {branches.map((branch) => (
                  <Option key={branch.id} value={branch.id}>
                    <span className="d-flex align-items-center">
                      <img
                        src={branch.logo || "assets/img/store/store-01.png"}
                        alt="logo"
                        style={{ width: 20, height: 20, marginRight: 8 }}
                      />
                      {branch.name}
                    </span>
                  </Option>
                ))}
              </Select>
            </li>
          )}
          {/* /Select Store */}

          {/* Only show POS/Dashboard button for non-owner users */}
          {(localUserData.user_type.toLowerCase() !== "owner") && (
            <li className="nav-item pos-nav">
              <Link
                to={getRedirectUrl()}
                className="btn btn-dark btn-md d-inline-flex align-items-center"
              >
                <i className="ti ti-device-laptop me-1"></i>
                {pathname === "/pos" ? "Dashboard" : "POS"}
              </Link>
            </li>
          )}

          {/* Flag */}
          {/* <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
            <Link
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              to="#"
              role="button"
            >
              <ImageWithBasePath
                src="assets/img/flags/us.png"
                alt="img"
                height={16}
              />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item active">
                <ImageWithBasePath
                  src="assets/img/flags/us.png"
                  alt="img"
                  height={16}
                />
                English
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/fr.png"
                  alt="img"
                  height={16}
                />{" "}
                French
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/es.png"
                  alt="img"
                  height={16}
                />{" "}
                Spanish
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/de.png"
                  alt="img"
                  height={16}
                />{" "}
                German
              </Link>
            </div>
          </li> */}
          {/* /Flag */}
          <li className="nav-item nav-item-box">
            <Link to="#" id="btnFullscreen" onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <FeatherIcon icon="maximize" />
            </Link>
          </li>
          {/* <li className="nav-item nav-item-box">
            <Link to="/email">
              <FeatherIcon icon="mail" />
              <span className="badge rounded-pill">1</span>
            </Link>
          </li> */}
          {/* Notifications */}
          {/* <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <FeatherIcon icon="bell" />
              <span className="badge rounded-pill">2</span>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  {" "}
                  Clear All{" "}
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message active">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-02.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-03.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Tarah Shropshire</span>{" "}
                            changed the task name{" "}
                            <span className="noti-title">
                              Appointment booking with payment gateway
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-06.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Misty Tison</span>{" "}
                            added{" "}
                            <span className="noti-title">Domenic Houston</span>{" "}
                            and <span className="noti-title">Claire Mapes</span>{" "}
                            to project{" "}
                            <span className="noti-title">
                              Doctor available module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-17.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Rolland Webber</span>{" "}
                            completed task{" "}
                            <span className="noti-title">
                              Patient and Doctor video conferencing
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-13.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Bernardo Galaviz</span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Private chat module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/activities">View all Notifications</Link>
              </div>
            </div>
          </li> */}

          <li className="nav-item main-drop first-li" style={{ padding: "5px" }}>
            <Dropdown menu={{ items: userMenuItems }} trigger={["click"]}>
              <div className="user-info" style={{ cursor: "pointer" }} aria-label="User profile menu">
                <span className="user-img">
                  <ImageWithBasePath src="assets/img/profiles/avator1.png"
                    alt="img" className="img-fluid"
                  />
                </span>
                <span className="user-detail" style={{marginLeft: '8px', marginTop: '-5px'}}>
                  <span className="user-name">{capitalizeFirstLetter(localUserData.name)}</span>
                  <span className="user-role">{capitalizeFirstLetter(localUserData.user_type)}</span>
                </span>
              </div>
            </Dropdown>
          </li>
        </ul>
        {/* /Header Menu */}

        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Dropdown
            menu={{
              items: [
                {
                  key: "profile",
                  label: (
                    <Link className="dropdown-item" to="profile">
                      My Profile
                    </Link>
                  ),
                },
                {
                  key: "logout",
                  label: (
                    <Link className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </Link>
                  ),
                },
              ],
            }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Link to="#" className="nav-link dropdown-toggle">
              <i className="fa fa-ellipsis-v" />
            </Link>
          </Dropdown>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
